<template>
    <div class="main-container">
        <div style="margin-top: 20px;" v-if="!isReadOnly">
            <el-button type="primary" @click="launch" size="mini" style="float: right;margin-left: 20px">提交</el-button>
            <el-button type="primary" @click="save(0)" size="mini" style="float: right">保存</el-button>
        </div>
        <div style="padding-top: 30px;">
            <contract ref="contract" :readonly="true" @callback="contractSelect"/>
            <order ref="order" :isOrderSettle="1" :readonly="isReadOnly" :zbjAmountWithTax="zbjAmountWithTax" :zbjAmountExclTax="zbjAmountExclTax"  :actualAmountExclTax="actualAmountExclTax" :actualAmountWithTax="actualAmountWithTax" @changeRegionalCompany="priceChoosed([])"/>
        </div>

        <div class="container">
            <section class="small-container">
                <h3 class="iconfont iconxiala">订单清单</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div>
                    <div style="padding: 0px 20px;" class="cf">
                        <priceTable ref="priceTable" :editable="!isReadOnly" :isOrderSettle="1" page="orderAdd" style="margin-top: -20px;"></priceTable>
                    </div>
                </div>
            </section>
            <section class="small-container">
                <h3 class="iconfont iconxiala">备注</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form status-icon inline-message inline label-width="200px" :disabled="isReadOnly">
                            <el-form-item label="备注：" class="noMarginBottom maxWidthForm">
                                <el-input
                                    type="textarea"
                                    :maxlength="500"
                                    size="mini"
                                    :rows="5"
                                    placeholder="请输入内容"
                                    v-model="remark"
                                >
                                </el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </section>
            <section class="small-container">
                <h3 class="iconfont iconxiala">附件</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form status-icon inline-message inline label-width="200px">
                            <el-form-item label="附件：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    :files="attachments"
                                    :editFlag="!isReadOnly"
                                    :attachmentType="91">
                                </page-upload>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </section>
        </div>
    </div>
</template>

<script>
    import Contract from "./components/contract";
    import Order from "./components/order";
    import jiesuan from "./components/jiesuan";
    import priceTable from '../order/components/priceTable';
    export default {
        name: "order-add",
        components: {
            Contract,
            Order,
            priceTable,
            jiesuan
        },
        computed: {
            isReadOnly(){
                if(this.type == 1 || this.type == 2){
                    return true;
                }else {
                    return false;
                }
            },
            actualAmountExclTax(){
                let sum = 0;
                let tempTableData = [...this.choosedPriceList];
                console.log(tempTableData, '1')
                tempTableData.forEach(item => {
                    let temp = this.$root.accMul(item.unitAmountExclTax||0, item.actualQuantities||0);
                    sum = this.$root.accAdd(sum, temp);
                });
                return sum;
            },
            actualAmountWithTax(){
                let sum = 0;
                let tempTableData = [...this.choosedPriceList];
                console.log(tempTableData, '2')
                tempTableData.forEach(item => {
                    let temp = this.$root.accMul(item.unitAmountWithTax||0, item.actualQuantities||0);
                    sum = this.$root.accAdd(sum, temp);
                });
                return sum;
            },
            zbjAmountWithTax(){
                let sum = 0;
                let tempTableData = [...this.choosedPriceList];
                console.log(tempTableData, '3')
                tempTableData.forEach(item => {
                    let temp = this.$root.accMul(item.unitAmountWithTax||0, item.actualQuantities||0);
                    sum = this.$root.accAdd(sum, temp);
                });
                return sum;
            },
            zbjAmountExclTax(){
                let sum = 0;
                let tempTableData = [...this.choosedPriceList];
                console.log(tempTableData, '4')
                tempTableData.forEach(item => {
                    let temp = this.$root.accMul(item.unitAmountWithTax||0, item.actualQuantities||0);
                    sum = this.$root.accAdd(sum, temp);
                });
                return sum;
            },
        },
        created() {
            let that = this;
            if(this.id){
                this.$root.getFunc('/v1/sOrders/getOrderDetail/'+this.id,function(res){
                    that.order = res.data.data;
                    // console.log(res)
                    let contractRef = that.$refs['contract'];
                    if(contractRef){
                        contractRef.contract = res.data.data.scontact;
                    }

                    let orderRef = that.$refs['order'];
                    if(orderRef){
                        orderRef.order = res.data.data;
                    }

                    that.remark = res.data.data.remarks;
                    that.attachments = res.data.data.attachmentVOS;
                    debugger
                    that.getCategoryInfo(res.data.data.scontact.categoryId, (data)=>{
                        let priceTableRef = that.$refs['priceTable'];
                        that.choosedPriceList = res.data.data.storeDetails.concat(res.data.data.newDetails)
                        if(priceTableRef){
                            priceTableRef.setData(that.choosedPriceList, data);
                        }
                    })
                },function(){
                    fn(false);
                })
            }
        },
        data(){
            return{
                type: this.$route.params.type ? this.$route.params.type : '4',//类型 1： 详情  2: 审批 3：编辑 4：新建
                id: this.$route.params.id,
                choosedPriceList: [],
                addedPriceList: [],

                remark: '',
                attachments: [],
                order: {},

                form: {
                    storeFlag: 1,
                    effectStartTime: '',
                    effectEndTime: '',
                },
            }
        },
        methods:{
            confirm(){
                let that = this;
                let form = that.$refs['priceForm'];
                if(Array.isArray(that.$refs['priceForm'])){
                    form = that.$refs['priceForm'][0]
                }
                form.validate((valid) => {
                    if(valid){
                        let formParams = {
                            dealId: this.$route.query.dealId,
                            orderId: this.id,
                            actionType: 2,
                            storeFlag: this.form.storeFlag,
                            // effectStartTime: this.form.effectStartTime,
                            // effectEndTime: this.form.effectEndTime
                        };
                        this.$root.postFunc('/v1/sOrders/approve',formParams,function(res){
                            that.$alert('提交成功', {
                                confirmButtonText: '确定',
                                type: 'success',
                                callback: action => {

                                }
                            });
                            that.$router.push('/order/list');
                        },function(){
                        })
                    } else {
                        this.$alert('请先填写必填信息',{
                            type: 'warning'
                        });
                        return;
                    }
                });
            },
            reject(){
                let that = this;
                let formParams = {
                    dealId: this.$route.query.dealId,
                    orderId: this.id,
                    actionType: 3,
                    storeFlag: 0
                };
                this.$root.postFunc('/v1/sOrders/approve',formParams,function(res){
                    that.$alert('提交成功', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {

                        }
                    });
                    that.$router.push('/order/list');
                },function(){
                })
            },
            priceChoosed(val){
                console.log(val)
                this.choosedPriceList = [...val];
                // this.choosedPriceList = this.choosedPriceList.map(item => {
                //     item.amountExclTax = this.$root.accMul(item.unitAmountExclTax, item.quantities);
                //     item.amountWithTax = this.$root.accMul(item.unitAmountWithTax, item.quantities);
                //     return item;
                // });
                let priceTableRef = this.$refs['priceTable'];
                if(priceTableRef){
                    priceTableRef.setData(this.choosedPriceList, this.$refs.priceChooseDialog.category);
                }
            },
            contractSelect(){
                debugger
                let contractRef = this.$refs['contract'];
                let orderRef = this.$refs['order'];
                if(orderRef && contractRef){
                    orderRef.filterId = contractRef.contract.regionalCompanyId.split(',');
                    this.getCategory(contractRef.contract.parentCategoryId, (data)=>{
                        let category = data.filter(item => {
                            return item.id == contractRef.contract.categoryId;
                        })[0];

                        let priceTableInputRef = this.$refs['priceTableInput'];
                        if(priceTableInputRef){
                            priceTableInputRef.setData(this.addedPriceList, category);
                        }
                    })
                }
                this.priceChoosed([]);
                orderRef.cleanForm();
            },
            getCategoryInfo(id,fn){
                let that = this;
                that.$root.getFunc('/v1/sSuppliersCategory/getCategoryInfo/'+id, function (res) {
                    fn && fn(res.data);
                })
            },
            getCategory(categoryId='', fn){
                let that = this;
                that.$root.postFunc('/v1/sSuppliersCategory/public/findSuppliersCategoryListByParent', {'categoryId': categoryId}, function (res) {
                    fn && fn(res.data);
                })
            },
            checkForm(){
                // debugger
                let checkPromise = [];

                let orderRef = this.$refs['order'];
                if(orderRef){
                    checkPromise.push(orderRef.submitFormPromise('order'));
                }

                let priceTableRef = this.$refs['priceTable'];
                if(priceTableRef){
                    checkPromise.push(priceTableRef.submitFormPromise('form'));
                }

                let priceTableInputRef = this.$refs['priceTableInput'];
                if(priceTableInputRef){
                    checkPromise.push(priceTableInputRef.submitFormPromise('form'));
                }

                return Promise.all(checkPromise).then(data=>{
                    return data;
                })
                    .catch(e => {
                        console.log(e);
                        return e;
                        // reject(e);
                    });
            },
            submitFormFnc(formName){
                let that = this;
                var f = function (){
                    const p = new Promise((resolve, reject) => {
                        let form = that.$refs[formName];
                        if(Array.isArray(that.$refs[formName])){
                            form = that.$refs[formName][0]
                        }
                        form.validate((valid) => {
                            if(valid){
                                resolve(true);
                            } else {
                                reject('请完成必填信息的填写！');
                            }
                        });
                    });
                    return p;
                }
                return f;
            },
            save(saveFlag, fn){
                let that = this;

                let priceTableRef = this.$refs['priceTable'];
                let priceTableInputRef = this.$refs['priceTableInput'];

                this.choosedPriceList = this.choosedPriceList.map(item => {
                    delete item.id;
                    item.listType = 1;
                    item.amountExclTax = this.$root.accMul(item.unitAmountExclTax, item.quantities);
                    item.amountWithTax = this.$root.accMul(item.unitAmountWithTax, item.quantities);
                    return item;
                })

                this.addedPriceList = this.addedPriceList.map(item => {
                    item.listType = 2;
                    item.amountExclTax = this.$root.accMul(item.unitAmountExclTax, item.quantities);
                    item.amountWithTax = this.$root.accMul(item.unitAmountWithTax, item.quantities);
                    return item;
                })


                let formParams = {
                    storeDetails: this.choosedPriceList,
                    newDetails: this.addedPriceList,
                    attachmentVOS: this.attachments,
                    remarks: this.remark,
                    saveFlag: saveFlag,
                    submitType: 1
                };

                let contractRef = this.$refs['contract'];
                if(contractRef){
                    formParams.contractId = contractRef.contract.id;
                }

                let orderRef = this.$refs['order'];
                if(orderRef){
                    formParams = Object.assign({}, formParams, orderRef.order);
                    formParams.saveFlag = saveFlag;
                    formParams.submitType = 1;
                }

                this.$root.postFunc('/v1/outerformflowHS/approveOrderSettle',formParams,function(res){
                    that.$alert(saveFlag == 1 ? '提交成功' : '保存成功', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                            if(saveFlag != 1){
                                window.close();
                            }
                        }
                    });
                },function(){
                    fn(false);
                })
            },
            launch(){
                let that = this;
                this.checkForm().then((res)=>{
                    if(Array.isArray(res)){
                        this.save(1, (result)=>{
                            if(result){
                                window.close();
                            }
                        });
                    }else {
                        this.$alert(res,{
                            type: 'warning'
                        });
                    }
                }).catch(e=>{
                    console.log(e);
                });
            },
            edit(){
                let contractRef = this.$refs['contract'];
                let orderRef = this.$refs['order'];
                if(contractRef && orderRef){
                    if(contractRef.contract.categoryId && contractRef.contract.categoryId.length > 0 && orderRef.order.projectId && orderRef.order.projectId.length > 0){
                        this.$refs.priceChooseDialog.multipleSelection = this.choosedPriceList.map(item => {
                            item.quantities = 1;
                            return item;
                        });
                        this.$refs.priceChooseDialog.show(contractRef.contract, orderRef.order.regionalCompanyId);

                    }else {
                        this.$alert('请先选择合同和项目',{
                            type: 'warning'
                        });
                        return;
                    }
                }
            }
        }
    }
</script>

<style lang='scss' scoped>
    //@import url(); 引入公共css类

    @import '../../assets/_var.scss';
    @import "../../assets/iconfont/iconfont.css";


    .main-container {
        width: 1100px;
        text-align: left;
    }


    .container /deep/{
        margin-top: -14px;
        padding-bottom: 15px;
        background-color: #ffffff;

        .el-message-box {
            width: 500px;
        }

        .text-button.el-button {
            font-size: 16px;
            text-align: left;
            color: #333333;
            line-height: 21px;
            background: white;
            border: none;
        }

        .f14 {
            font-size: 14px!important;
        }

        & .unit {
            width: 100px;
            margin-right: 5px;
        }

        & .tip {
            margin-left: 10px;
            color: $--primary-color;
            font-size: 12px;
        }

        & .add {
            float: right;
            font-size: 14px;
            cursor: pointer;
            & img {
                vertical-align: middle;
                width: 70px;
                height: 26px;
            }
        }
        & .dele {
            position: absolute;
            top: 0px;
            right: 10px;
        }
        & .dele img {
            transform: scale(1);
            transition: .5s;
            width: 34px;
            height: 34px;
        }
        .dele:hover img {
            transform: scale(1.1);
        }
        & .remarks {
            width: 95%;
        }

        & .naturalForm  {
            padding: 20px 10px 5px;
            padding-left: 0px;
            padding-right: 26px;
            border: 1px solid #dcdfe6;
            border-radius: 3px;
            margin-bottom: 20px;
        }

        & h4{
            padding: 0 30px;
            text-align: left;
            line-height: 50px;
            color: $--text-color-light;
            background: $--secondary-fill-color;
            overflow: hidden;
            position: relative;

        }
        & h4 {
            text-indent: 10px;
            line-height: 35px;
            background: $--primary-fill-color;
        }

        .attachmentForm {
            .el-form-item__content {
                // width: 250px;
            }
        }

        .el-input__inner {
            border: none;
            border-bottom: 1px solid #C4C4C4;
            border-radius: 0px;
        }

        .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
            background-color: white;
            cursor: default;
        }

        .maxWidthForm {
            width: 100%;
            .el-form-item__content {
                width: calc(100% - 260px);
            }
        }

        .onlySupplier {
            .file-list .file-name {
                max-width: 190px!important;
            }
        }

        .el-form-item {
            width: 100%;
        }

        .el-form-item__error {
            width: 300px;
            padding: 0;
        }

        .el-form-item__label, .el-form-item__content{
            line-height: 33px;
        }

        .tag {
            .el-button {
                border-bottom-left-radius: 0px;
                border-bottom-right-radius: 0px;
            }
        }
    }
    .box-card{
        margin-bottom: 15px;
    }
    .minWidth{
        width: 250px;
    }
    h3{
        // background-color: #ececec;
        padding: 0 20px 5px;
        margin: 0;
        // margin-top: 10px;
        position: relative;
        cursor: pointer;
        padding-left: 25px;
    }

    .iconxiala::before {
        position: absolute;
        left: 0px;
        font-size: 20px;
    }

    .colorLine {
        margin-top: 10px;
        margin-bottom: 20px;
        padding-left: 20px;
    }

    h2 {
        font-size: 13px;
        margin-left: 20px;
    }
    .noMarginBottom{
        // margin-bottom: 0!important;
        margin-bottom: 10px!important;
        .tipWrap {
            position: relative;
            min-width: 250px;
            .tips {
                position: absolute;
                top: 16px;
                left: 100px;
                padding-left: 20px;
                font-size: 12px;
                color: $--text-color-light;
            }
        }
    }

    .cf:before,.cf:after {
        content:"";
        display:table;
    }
    .cf:after { clear:both; }
    .marg-top-cls{
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/order/add.vue